import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs';
import { ResponseData } from '../../nest-responses';
import {
  RequestJobDescriptionDto,
  RequestNewHireCheckListDto,
  RequestNewHireTrainingDto,
  RequestOnBoardingDto,
  ResponseJobDescriptionDto,
  ResponseNewHireCheckListDto,
  ResponseNewHireTrainingDto,
  ResponseOnBoardingDto,
  ResponseGetPercentOnBoardingNewCompany,
  RequestChecklistOnBoardingNewCompanyDto,
  ResponseChecklistOnBoardingNewCompanyDto,
} from '../dto/on-boarding.dto';

@Injectable()
export class OnBoardingApi {

  private readonly service: string = '';
  private readonly model: string = 'onBoarding';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getOnBoardingData(payload: RequestOnBoardingDto): Observable<ResponseData<ResponseOnBoardingDto>> {
    const method: string = 'POST';
    const func: string = '';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseOnBoardingDto>>(method, url, params, urlParams, body);
  }

  public jobsDescription(payload: RequestJobDescriptionDto): Observable<ResponseData<ResponseJobDescriptionDto>> {
    const method: string = 'POST';
    const func: string = 'jobsDescription';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseJobDescriptionDto>>(method, url, params, urlParams, body);
  }

  public newHireChecklist(payload: RequestNewHireCheckListDto): Observable<ResponseData<ResponseNewHireCheckListDto[]>> {
    const method: string = 'POST';
    const func: string = 'newHireChecklist';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseNewHireCheckListDto[]>>(method, url, params, urlParams, body);
  }

  public newHireTraining(payload: RequestNewHireTrainingDto): Observable<ResponseData<ResponseNewHireTrainingDto[]>> {
    const method: string = 'POST';
    const func: string = 'newHireTraining';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseNewHireTrainingDto[]>>(method, url, params, urlParams, body);
  }

  public getPercentOnBoardingNewCompany() {
    const method: string = 'GET';
    const func: string = 'getPercentOnBoardingNewCompany';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetPercentOnBoardingNewCompany>>(method, url, params, urlParams, body, null, null, null, false);
  }

  public checklistOnBoardingNewCompany(payload?: RequestChecklistOnBoardingNewCompanyDto) {
    const method: string = 'POST';
    const func: string = 'checklistOnBoardingNewCompany';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseChecklistOnBoardingNewCompanyDto>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/on-boarding.api.ts